import React from 'react'
import Popup from './Popup'
import Button from './Button'

const AlertPopup: React.FC<{
  message: string
  buttonLabel: string
  onClose: () => void
}> = (props) => {
  return (
    <Popup onClose={props.onClose}>
      <div className="title">
        {props.message
          .split('\n')
          .map((line, index, array) => (
            <React.Fragment key={index}>
              {index > 0 && (<br />)}
              {line}
            </React.Fragment>
          ))
        }
      </div>
      <div className="buttonStack">
        <Button onClick={props.onClose}>
          {props.buttonLabel}
        </Button>
      </div>
    </Popup>
  )
}

export default AlertPopup
